var l="object"==typeof global&&global&&global.Object===Object&&global;export{l as default};
//# sourceMappingURL=_freeGlobal.js.map
